<template>
    <div>
        <div class="top-bar flex justify-end">
            <v-button 
                icon="plus" 
                @click="goToPage('add-cost')" 
                class="ml-4" 
                :disabled="showFormImportEntities"
            >
                {{ $t(type === 0 ? 'add_indirect_cost_chapter' : 'add_direct_cost_chapter') }}
            </v-button>
        </div>
        <!-- Tabla de Costos -->
        <cost-table 
            :projectId="projectId" 
            :type="type" 
            ref="costs_table" 
            @epc-edit="handleEditCost" 
        />
        <cost-modal 
            ref="cost_modal" 
            :projectId="projectId" 
            :type="type" 
            @reload-list="handleReload" 
        />
    </div>
</template>

<script>
import CostTable from "./cost-table.vue";
import CostModal from "./cost-modal.vue";

export default {
    components: {
        CostTable,
        CostModal,
    },
    props: {
        projectId: {
            type: Number,
            required: true,
        },
        type: {
            type: Number,
            required: true, // 0 = indirecto, 1 = directo
        },
    },
    data() {
        return {
            showFormImportEntities: false,
            showFormData: false,
        };
    },
    methods: {
        handleReload() {
            this.$refs.costs_table.reload();
        },
        openCost(cost) {
            this.$refs.cost_modal.show(cost);
        },
        handleEditCost(cost) {
            this.openCost(cost);
        },
        goToPage(destiny) {
            switch (destiny) {
                case 'add-cost':
                this.$router.push({
                name: 'project.admin.cost-management.cost-detail',
                params: { project_id: this.projectId, type:this.type }, 
                });
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>